(function () {
  'use strict';

  var apiPromise = null;

  function loadYouTubeApi() {
    if (apiPromise) return apiPromise;
    apiPromise = new Promise(function (resolve) {
      if (window.YT && window.YT.Player) {
        resolve(window.YT);
        return;
      }
      var previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof previous === 'function') previous();
        resolve(window.YT);
      };
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    });
    return apiPromise;
  }

  function Carousel(root) {
    this.root = root;
    try {
      this.videos = JSON.parse(root.querySelector('[data-fdp-video-data]').textContent || '[]');
    } catch (err) {
      this.videos = [];
    }
    this.stageA = root.querySelector('[data-fdp-stage-a]');
    this.stageB = root.querySelector('[data-fdp-stage-b]');
    this.dotsWrap = root.querySelector('[data-fdp-dots]');
    this.current = 0;
    this.activeStage = this.stageA;
    this.idleStage = this.stageB;
    this.transitioning = false;
    if (this.videos.length) this.start();
  }

  Carousel.prototype.buildDots = function () {
    var self = this;
    this.videos.forEach(function (v, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'fdp-carousel__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Play video ' + (i + 1));
      dot.addEventListener('click', function () {
        self.advanceTo(i);
      });
      self.dotsWrap.appendChild(dot);
    });
  };

  Carousel.prototype.updateDots = function () {
    var dots = this.dotsWrap.querySelectorAll('.fdp-carousel__dot');
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === this.current);
    }, this);
  };

  Carousel.prototype.start = function () {
    var self = this;
    this.buildDots();
    loadYouTubeApi().then(function (YT) {
      self.YT = YT;
      self.activeStage.fdpPlayer = self.createPlayer(self.activeStage, self.videos[self.current].id);
    });
  };

  // The onStateChange handler checks `stage === self.activeStage` at fire time
  // rather than capturing an "isActive" flag, so a stray event from a player
  // that is mid-transition-out (or already destroyed) can never trigger a
  // second, conflicting advance.
  Carousel.prototype.createPlayer = function (stage, videoId) {
    var self = this;
    var mount = stage.querySelector('[data-fdp-mount]');
    mount.innerHTML = '<div></div>';
    var target = mount.firstChild;
    return new this.YT.Player(target, {
      videoId: videoId,
      playerVars: {
        autoplay: 1,
        mute: 1,
        controls: 1,
        rel: 0,
        playsinline: 1,
        modestbranding: 1,
      },
      events: {
        onStateChange: function (e) {
          if (stage !== self.activeStage || e.data !== self.YT.PlayerState.ENDED) return;
          if (self.videos.length < 2) {
            e.target.seekTo(0);
            e.target.playVideo();
            return;
          }
          self.advanceTo((self.current + 1) % self.videos.length);
        },
      },
    });
  };

  Carousel.prototype.advanceTo = function (index) {
    if (index === this.current || this.transitioning) return;
    this.transitioning = true;

    var incomingStage = this.idleStage;
    var outgoingStage = this.activeStage;
    var incomingId = this.videos[index].id;

    incomingStage.classList.remove('is-prev', 'is-active', 'is-next');
    incomingStage.classList.add('is-next');
    // force reflow so the transition below actually animates
    void incomingStage.offsetWidth;

    if (incomingStage.fdpPlayer && incomingStage.fdpPlayer.destroy) incomingStage.fdpPlayer.destroy();
    incomingStage.fdpPlayer = this.createPlayer(incomingStage, incomingId);

    requestAnimationFrame(function () {
      incomingStage.classList.remove('is-next');
      incomingStage.classList.add('is-active');
      outgoingStage.classList.remove('is-active');
      outgoingStage.classList.add('is-prev');
    });

    var self = this;
    setTimeout(function () {
      // Only now is the outgoing video actually off-screen — safe to tear it down.
      if (outgoingStage.fdpPlayer && outgoingStage.fdpPlayer.destroy) outgoingStage.fdpPlayer.destroy();
      outgoingStage.fdpPlayer = null;

      self.current = index;
      self.activeStage = incomingStage;
      self.idleStage = outgoingStage;
      self.updateDots();
      self.transitioning = false;
    }, 650);
  };

  function initAll() {
    document.querySelectorAll('[data-fdp-carousel]').forEach(function (root) {
      new Carousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
